<template>
  <vue-modal classes="vue-modal-container"
             height="auto"
             name="change-phone-number-modal"
             width="300px">
    <div class="header">
      <h3>{{ trans.header }}</h3>
      <button class="close-modal"
              @click="$modal.hide('change-phone-number-modal')">
        <i class="close icon"/>
      </button>
    </div>
    <div class="content">
      <div class="ui form">
        <div class="field">
          <vue-tel-input v-model="newPhoneNumber"
                         :placeholder="phoneInputPlaceholder"
                         defaultCountry="HU"
                         @onInput="phoneUpdate"></vue-tel-input>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui positive button"
              @click="updatePhoneNumber">{{ trans.changePhoneNumberBtnText }}
      </button>
    </div>
  </vue-modal>
</template>

<script>
import 'vue-tel-input/dist/vue-tel-input.css'
import VueTelInput from 'vue-tel-input'
import notify from '@/notify'
import {mapState} from 'vuex'

export default {
  data () {
    return {
      newPhoneNumber: null,
      isNewPhoneNumberValid: false,
    }
  },
  methods: {
    updatePhoneNumber () {
      if (this.isNewPhoneNumberValid) {
        this.$emit('updatePhoneNumber', this.newPhoneNumber)
      } else if (this.newPhoneNumber === '' || !this.newPhoneNumber) {
        notify.confirmation('Biztos törlöd a telefonszámod a rendszerből?')
          .then(() => {
            this.$emit('updatePhoneNumber', '')
          }, () => {
            // no
          })
      } else {
        notify.warning('Adj meg egy helyes telefonszámot')
      }
    },
    // eslint-disable-next-line no-unused-vars
    phoneUpdate ({ number, isValid, country }) {
      // console.log('--- phoneUpdateTest:')
      // console.log(number, isValid, country)
      this.isNewPhoneNumberValid = isValid
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.changePhoneNumberModal,
    }),
    phoneInputPlaceholder () {
      const defaultText = this?.trans?.placeholder ? this.trans.placeholder : 'Adja meg telefonszámát'
      // eslint-disable-next-line no-prototype-builtins
      return this.$store.state.user.hasOwnProperty('phone') ? this.$store.state.user.phone === '' ? defaultText : this.$store.state.user.phone : defaultText
    },
  },
  components: {
    VueTelInput,
  },
}
</script>

<style scoped>

</style>
